import { Injectable } from '@angular/core';
import { registerModuleFactory } from '@angular/core/src/linker/ng_module_factory_loader';

@Injectable()
export class UserFriendlyErrorService {
  errors: any[] = [];

  constructor() {
    this.errors.push({
      url: '/api/status/all',
      serverErrorMessage:
        'An unhandled exception occurred while loading status list'
    });
    this.errors.push({
      url: '/api/state/all',
      serverErrorMessage:
        'An unhandled exception occurred while loading list of states'
    });
    this.errors.push({
      url: '/api/county/by/state',
      serverErrorMessage:
        'An unhandled exception occurred while loading county list'
    });
    this.errors.push({
      url: '/api/district/by/county',
      serverErrorMessage:
        'An unhandled exception occurred while loading districts'
    });
    this.errors.push({
      url: '/api/region/all',
      serverErrorMessage:
        'An unhandled exception occurred while loading regions'
    });
    this.errors.push({
      url: '/api/orgcategory/all',
      serverErrorMessage:
        'An unhandled exception occurred while loading categories'
    });
    this.errors.push({
      url: '/api/headend/by/region',
      serverErrorMessage:
        'An unhandled exception occurred while loading headends'
    });
    this.errors.push({
      url: '/api/organization/filter/skip',
      serverErrorMessage:
        'An unhandled exception occurred while loading organizations'
    });
    this.errors.push({
      url: '/api/organization/delete',
      serverErrorMessage:
        'An unhandled exception occurred while deleting organization'
    });
    this.errors.push({
      url: '/api/organization/get',
      serverErrorMessage:
        'An unhandled exception occurred while loading organization details'
    });
    this.errors.push({
      url: '/api/organization/save',
      serverErrorMessage:
        'An error occurred updating organization information. No changes applied'
    });
    this.errors.push({
      url: '/upload/sound',
      serverErrorMessage:
        'An unhandled exception occurred while uploading sound file'
    });
    this.errors.push({
      url: '/status/update',
      serverErrorMessage:
        'An unhandled exception occurred while updating organization status'
    });
    this.errors.push({
      url: '/status/get',
      serverErrorMessage:
        'An unhandled exception occurred while loading organization status'
    });
    this.errors.push({
      url: '/adminsounds/all/',
      serverErrorMessage:
        'An unhandled exception occurred while loading admin sounds'
    });
    this.errors.push({
      url: '/adminsounds/region/upload',
      serverErrorMessage:
        'An unhandled exception occurred while uploading admin sound file'
    });
    this.errors.push({
      url: '/adminsounds/region/play',
      serverErrorMessage:
        'An unhandled exception occurred while loading admin sound file'
    });
    this.errors.push({
      url: '/adminsounds/region/delete',
      serverErrorMessage:
        'An unhandled exception occurred while deleting admin sound file'
    });

    this.errors.push({
      url: '/api/status/filt',
      serverErrorMessage:
        'An unhandled exception occurred while loading statuses'
    });
    this.errors.push({
      url: '/api/status/delete',
      serverErrorMessage:
        'An unhandled exception occurred while deleting status'
    });
    this.errors.push({
      url: '/api/status/upload',
      serverErrorMessage:
        'An unhandled exception occurred while uploading status sound file'
    });
    this.errors.push({
      url: '/api/status/save',
      serverErrorMessage:
        'An unhandled exception occurred while saving status'
    });
    this.errors.push({
      url: '/api/status/get',
      serverErrorMessage:
        'An unhandled exception occurred while loading statuses'
    });
    this.errors.push({
      url: '/api/region/get',
      serverErrorMessage:
        'An unhandled exception occurred while loading status'
    });
    this.errors.push({
      url: '/api/adminsounds/all',
      serverErrorMessage:
        'An unhandled exception occurred while loading list of admin sounds'
    });
    this.errors.push({
      url: '/api/switchstatustimes/get',
      serverErrorMessage:
        'An unhandled exception occurred while loading list of switch status times'
    });
    this.errors.push({
      url: '/api/switchstatustimes/save',
      serverErrorMessage:
        'An unhandled exception occurred while saving switch status time'
    });
    this.errors.push({
      url: '/api/organization/status/update',
      serverErrorMessage:
        'An unhandled exception occurred while saving organization status'
    });
    this.errors.push({
      url: '/api/organization/status/get',
      serverErrorMessage:
        'An unhandled exception occurred while loading organization status'
    });
    this.errors.push({
      url: '/api/statusendtimerules/save',
      serverErrorMessage:
        'An unhandled exception occurred while saving status end time rules'
    });
    this.errors.push({
      url: '/api/statusendtimerules/get',
      serverErrorMessage:
        'An unhandled exception occurred while loading status end time rules'
    });
    this.errors.push({
      url: '/api/statusendtimerules/delete',
      serverErrorMessage:
        'An unhandled exception occurred while deleting status end time rules'
    });
  }

  getErrorMessage(url: string) {
    const userFriendlyMessage = this.errors.filter(
      m => url.indexOf(m.url) > -1
    );
    if (userFriendlyMessage.length > 0) {
      return userFriendlyMessage[0].serverErrorMessage;
    } else {
      return 'An unhandled exception occurred';
    }
  }

  buidlDetailsPart(details: string) {
    let html = `<div>
      <a onclick="$(this).next().is(':visible') ? $(this).next().hide() : $(this).next().show(); event.stopPropagation();"
        class="see-details" data-toggle="collapse" aria-controls="exception">See details</a>
        <div id="exception" style="display:none; " class="exception">{details}</div>
        </div>`;
    html = html.replace('{details}', details);
    return html;
  }

  getErrorMessageWithDetails(url: string, error: any) {
    let errorMessage = this.getErrorMessage(url);
    if (error && error.message) {
      errorMessage += this.buidlDetailsPart(error.message);
    }

    return errorMessage;
  }
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/shared/services/user-friendly-error.service.ts